import React from "react";
import "./HowToOrder.css";
import vinImg from "../../Assets/howTo/vinImage.PNG";
import dataImage from "../../Assets/howTo/dataImage.PNG";
import warrentyImg from "../../Assets/howTo/warrenty.PNG";
import pkgImg from "../../Assets/howTo/pkg.PNG";
import { Helmet } from "react-helmet";



export default function HowToOrder() {
  return (
    <>                                <Helmet>
    <title>How to Order</title>
  </Helmet>
      <div className="howtoorder">
        <div className="container">
          <h2 className="heading py-3">How to Order</h2>
          <div className="sections">
            <div className="section one mb-3">
              <h5 className="fs-4 fw-500">
                1-Requesting Driving Service on Driving Data:
              </h5>
              <ul className=" main-list">
                <div className="list-details d-flex gap-3 align-items-center justify-content-between">
                  <div>
                    <li className="main-color fs-5 fw-500 heading">
                      Vehicle Number (VIN) Registration:
                    </li>
                    <ul>
                      <li>- Enter your vehicle's VIN in the field provided.</li>
                      <li>
                        - The VIN can be found in the vehicle documents or on
                        the vehicle plate.
                      </li>
                    </ul>
                  </div>
                  <div className="photo">
                    <img src={vinImg} alt="vinImg" width={500} />
                  </div>
                </div>

                <li className="bg-black text-white p-2 my-4 rounded-3">
                  <span className="main-color fw-500">Note:</span> If you prefer
                  to enter vehicle data manually, you can go to the next option.
                </li>

                <div className="list-details d-flex gap-3 align-items-center justify-content-between">
                  <div>
                    <li className="main-color fs-5 fw-500 heading">
                      Manually enter vehicle data:
                    </li>
                    <ul>
                      <li>
                        - If you do not have the VIN number, enter the data
                        manually:
                      </li>
                      <ul>
                        <li>1- Car brand</li>
                        <li>2- The Model</li>
                        <li>3- The Year</li>
                      </ul>
                    </ul>
                  </div>
                  <div className="photo">
                    <img src={dataImage} alt="dataImage" width={490} />
                  </div>
                </div>

                <div className="list-details d-flex gap-3 align-items-center justify-content-between my-4">
                  <div>
                    <li className="main-color fs-5 fw-500 heading">
                      Determine warranty status:
                    </li>
                    <ul>
                      <li>
                        - Choose whether your vehicle is under warranty or out
                        of warranty.
                      </li>
                      <li>
                        <span className="main-color">
                          - If it is under warranty:
                        </span>
                        You will be presented with the options available based
                        on your warranty agreement.
                      </li>
                      <li>
                        <span className="main-color">
                          - If it is out of warranty:
                        </span>
                        You can continue choosing the package or customize your
                        package.
                      </li>
                    </ul>
                  </div>
                  <div className="photo">
                    <img src={warrentyImg} alt="warrentyImg" width={200} />
                  </div>
                </div>
              </ul>
            </div>

            <div className="section two mb-3">
              <h5 className="fs-4 fw-500">
                2-Choose the package:
              </h5>
              <ul className=" main-list">
                <div className="list-details d-flex gap-3 mb-4 flex-column justify-content-between">
                  <div>
                    <li className="main-color fs-5 fw-500 heading">
                    Choose your own package:
                    </li>
                    <ul>
                      <li>- Browse our ready-made packages that suit your car type and needs..</li>
                      <li>
                        - You can easily choose from the available options.
                      </li>
                    </ul>
                  </div>
                  <div className="photo">
                    <img src={pkgImg} alt="pkgImg" width={500} />
                  </div>
                </div>


                <div className="list-details d-flex gap-3 flex-column justify-content-between">
                  <div>
                    <li className="main-color fs-5 fw-500 heading">
                    Customize your package yourself:
                    </li>
                    <ul>
                      <li>
                        <span className="main-color">If your car is out of warranty:</span>You can customize your package based on your needs.
                      </li>

                    </ul>
                  </div>
                  <div className="photo">
                  <img src={pkgImg} alt="pkgImg" width={500} />
                  </div>
                </div>

                <div className="list-details d-flex gap-3 align-items-center justify-content-between my-4">
                  <div>
                    <li className="main-color fs-5 fw-500 heading">
                    Complete the request:
                    </li>
                    <ul>
                      <li>
                      - Once you have selected or customized your package, click “Online Payment”.
                      </li>
                      <li>
                       - Enter your payment details and delivery address (if required).
                      </li>
                      <li>
                        - Make sure to review all details before confirming your order.
                      </li>
                    </ul>
                  </div>
                  <div className="photo">
                    <img src={warrentyImg} alt="warrentyImg" width={200} />
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
